<template>
  <div>
    <Head title="Local Suppliers" />
    <div class="flex items-center justify-between mb-6 mt-6">
      <h1 class="mb-8 text-3xl font-bold">
        <Link class="text-orange-400 hover:text-orange-600" :href="`/localSuppliers/${supplier.supplier_id}/supplierSkus`">
          {{ supplier.name }}
        </Link>
        <span class="text-orange-400 font-medium">/</span> Edit SKU

      </h1>
       <Link class="btn-orange" :href="`/localSuppliers/${supplier.supplier_id}/supplierSkus/create`">
        <span>Add</span>
        <span class="hidden md:inline">&nbsp;SKU</span>
      </Link>    
    </div>
    <div class="max-w-full bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-16 -mr-6 p-8 mb-3">
          <div class="pb-8 pr-6 w w-full lg:w-full">
            <multiselect
              v-model="selectedSku"
              id="sku_id"
              placeholder="Search SKU"
              :options="skus"
              :close-on-select="true"
              :searchable="true"
              :error="form.errors.sku_id"
              :style= "form.errors.sku_id ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''"
              @search-change="onSearchSkusChange"
              @input="onSelectedSku"
            />
            <div v-if="form.errors.sku_id" class="form-error">{{ form.errors.sku_id }}</div>
            <small><em>{{form.name }} ~ {{form.description }}</em></small>
          </div>
          <text-input v-model="form.order_placed" type="text" :error="form.errors.order_placed" class="pb-8 pr-6 w-full lg:w-1/2" label="Lead Time" />
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100 mt-4">
          <loading-button :loading="form.processing" class="btn-orange" type="submit">Update Supplier SKU</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Multiselect from '@vueform/multiselect'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    Multiselect,
  },
  layout: Layout,
  remember: 'form',
  props: {
    skus: {
      type: Array,
      default: () => []
    },
    supplier: Array,
  },
  data() {
    return {
      form: this.$inertia.form({
        _method: 'put',
        name: this.supplier.part_number,
        description: this.supplier.description,
        order_placed: this.supplier.order_placed,
        sku_id: this.supplier.sku_id,
      }),
      selectedSku: null,
    }
  },
  methods: {
    update() {
      this.form.post(`/localSuppliers/${this.supplier.supplier_id}/supplierSkus/${this.supplier.id}`)
    },
    onSearchSkusChange: throttle(function (search) {
        this.$inertia.get(`/localSuppliers/${this.supplier.supplier_id}/supplierSkus/${this.supplier.id}/edit`, {search}, {
          preserveState: true,
          preserveScroll: true,
          replace: true
        })
      }, 200),
    onSelectedSku(sku, id) {
      this.form.sku_id = sku;
    },
  },
}
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
<style type="text/css">
  .multiselect-option.is-selected.is-pointed {
    background: var(--ms-option-bg-selected-pointed,#fb923c);
    color: var(--ms-option-color-selected-pointed,#fff);
  }
  .multiselect-option.is-selected {
    background: var(--ms-option-bg-selected-pointed,#fb923c);
    color: var(--ms-option-color-selected-pointed,#fff);
  }
</style>
